const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function inclusiveMonthCount(fromIso: string, toIso: string): number | null {
    const fromMatch = ISO_DATE.exec(fromIso);
    const toMatch = ISO_DATE.exec(toIso);
    if (!fromMatch || !toMatch) return null;

    const fromYear = Number(fromMatch[1]);
    const fromMonth = Number(fromMatch[2]);
    const fromDay = Number(fromMatch[3]);
    const toYear = Number(toMatch[1]);
    const toMonth = Number(toMatch[2]);
    const toDay = Number(toMatch[3]);

    const from = new Date(fromYear, fromMonth - 1, fromDay);
    const to = new Date(toYear, toMonth - 1, toDay);
    if (
        from.getFullYear() !== fromYear ||
        from.getMonth() !== fromMonth - 1 ||
        from.getDate() !== fromDay ||
        to.getFullYear() !== toYear ||
        to.getMonth() !== toMonth - 1 ||
        to.getDate() !== toDay ||
        to < from
    ) {
        return null;
    }

    return (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1;
}
